import MeetingGroupPicker from "../../components/MeetingGroupPicker";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import Env from "../../runtimeEnv";

const UpdateMeetingForm = () => {
  const { register, handleSubmit, setValue, watch, reset } = useForm();
  const [meetingID, setMeetingID] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [clients, setClients] = useState([""]);

  // Therapist list (same as CreateMeeting)
  const therapists = [
    { name: "Test User - James", email: "jshu@plutonic.co" },
    { name: "Jeanette Gurr", email: "jgurr@plutonic.co" },
    { name: "Abigail Rozeboom", email: "arozeboom@plutonic.co" },
    { name: "Ashi Patel", email: "apatel@plutonic.co" },
    { name: "Stephanie Branom", email: "sbranom@plutonic.co" },
    { name: "Cooper Morgan", email: "cmorgan@plutonic.co" },
    { name: "Jessica Sigur", email: "jsigur@plutonic.co" },
    { name: "Briauna Brownfield, LMSW", email: "briaunaterie@gmail.com" },
    { name: "Kazia Cortel-Fraser", email: "kcortelfraser@plutonic.co" },
	{ name: "Test User - Matthew", email: "mjwebster61@outlook.com" },
    { name: "Test User - Andrew", email: "plphpps@gmail.com" },
  ];

  // Autofill therapist email
  const handleTherapistChange = (event) => {
    const therapistEmail =
      therapists.find((t) => t.name === event.target.value)?.email || "";
    setValue("therapistEmail", therapistEmail);
  };

  // Client input handlers
  const addClient = () => setClients((prev) => [...prev, ""]);

  const removeClient = (index) =>
    setClients((prev) => prev.filter((_, i) => i !== index));

  const updateClient = (index, value) =>
    setClients((prev) => {
      const next = [...prev];
      next[index] = value;
      return next;
    });

  // SUBMIT
  const onSubmit = async (formData) => {
    setLoading(true);
    setMessage(null);

    try {
      // Normalize emails
      let validEmails = clients
        .map((e) => (e ?? "").trim().toLowerCase())
        .filter((e) => e !== "");

      if (validEmails.length === 0) {
        setMessage({
          type: "error",
          text: "Please provide at least one client email.",
        });
        return;
      }

      // Validate duplicates
      const duplicates = validEmails.filter(
        (e, i) => validEmails.indexOf(e) !== i
      );
      if (duplicates.length > 0) {
        setMessage({
          type: "error",
          text: `Duplicate client email(s): ${duplicates.join(", ")}`,
        });
        return;
      }

      const therapistEmail =
        formData.therapistEmail?.trim().toLowerCase() || null;

      if (therapistEmail && validEmails.includes(therapistEmail)) {
        setMessage({
          type: "error",
          text: `Therapist email cannot also be a client.`,
        });
        return;
      }

      // Build payload (same as old logic)
      // Build payload using new unified format
      const payload = {
      meetingID,
        clientEmails: validEmails,
        therapistEmail,
        sessionTime: formData.sessionTime || null,
        meetingName: formData.meetingName || null
      };

      const response = await axios.put(
        `${Env.REACT_APP_PYTHON_API_URL}/api/admin/update-meeting`,
        payload
      , { withCredentials: true });

      setMessage({
        type: "success",
        text: "Meeting updated successfully.",
      });

      setMeetingID("");
      reset();
      setClients([""]);
    } catch (error) {
      console.error("UpdateMeetingForm.js: error event");
      setMessage({
        type: "error",
        text:
          error.response?.data?.message ||
          "Update Meeting failed — please verify your inputs.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {message && (
        <div
          className={`p-2 text-center ${
            message.type === "success" ? "text-green-600" : "text-red-600"
          }`}
        >
          {message.text}
        </div>
      )}

      <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
        {/* Clients */}
        <div className="space-y-2">
          <label className="block font-medium">Client Emails</label>
          {clients.map((email, index) => (
            <div key={index} className="flex gap-2">
              <input
                type="email"
                value={clients[index] ?? ""}
                onChange={(e) => updateClient(index, e.target.value.trimStart())}
                placeholder="Client Email"
                className="input-field flex-grow"
                required={index === 0}
              />
              {index > 0 && (
                <button
                  type="button"
                  onClick={() => removeClient(index)}
                  className="px-2 rounded bg-red-500 text-white"
                >
                  🗑️
                </button>
              )}
              {index === clients.length - 1 && (
                <button
                  type="button"
                  onClick={addClient}
                  className="px-2 rounded bg-blue-500 text-white"
                >
                  +
                </button>
              )}
            </div>
          ))}
        </div>

        {/* Meeting Name (optional now) */}
        <input
          {...register("meetingName")}
          placeholder="Meeting Name (optional)"
          className="input-field"
        />

        {/* Time (optional but recommended) */}
        <input
          type="datetime-local"
          {...register("sessionTime")}
          className="input-field"
        />

        {/* Therapist dropdown */}
        <select
          {...register("therapist")}
          className="input-field"
          onChange={handleTherapistChange}
        >
          <option value="">Select a Therapist</option>
          {therapists.map((therapist, index) => (
            <option key={index} value={therapist.name}>
              {therapist.name}
            </option>
          ))}
        </select>

        {/* Auto-filled Therapist Email */}
        <input
          {...register("therapistEmail")}
          placeholder="Therapist Email"
          readOnly
          className="input-field bg-gray-200 cursor-not-allowed"
        />

        <MeetingGroupPicker clientEmails={clients} therapistEmail={watch("therapistEmail")} value={meetingID} onChange={setMeetingID} />

            {/* Submit */}
        <button type="submit" className="button-primary" disabled={loading || !meetingID}>
          {loading ? "Updating Meeting..." : "Update Meeting"}
        </button>
      </form>
    </>
  );
};

export default UpdateMeetingForm;
